<div class="app-footer">
	<div class="row">
		
	</div>
	
</div>